import * as React from 'react'
import { UserDocument } from '../lib/userDocuments.slice'
import {
  DocumentsSearchBar,
  DocumentSearchBarOnChangeData,
} from './DocumentsSearchBar'

interface DocumentsToolbarProps {
  children?: React.ReactNode
  documents: UserDocument[]
  onSearch: (_data: DocumentSearchBarOnChangeData) => void
  rightElement?: React.ReactNode
}

export const TabPaneToolbar: React.FC<DocumentsToolbarProps> = ({
  children,
  documents,
  onSearch,
  rightElement,
}) => {
  return (
    <div className="flex flex-col space-y-4">
      {children}

      <div className="flex flex-col sm:flex-row space-x-8 justify-between items-center gap-4 sm:gap-2">
        <div className="w-full sm:w-4/5">
          <DocumentsSearchBar documents={documents} onChange={onSearch} />
        </div>
        <div className="w-full sm:w-1/5">{rightElement}</div>
      </div>
    </div>
  )
}
